import React from 'react';
import ManagedPropertySuccess from '../../components/landlord-toolkit/ManagedPropertySuccess';

const ManagedPropertySuccessPage: React.FC = () => {
  const handleViewManaged = () => window.location.assign('/landlord-toolkit/managed-properties');
  const handleAddAnother = () => window.location.assign('/landlord-toolkit/add-property');

  return (
    <ManagedPropertySuccess onViewManaged={handleViewManaged} onAddAnother={handleAddAnother} />
  );
};

export default ManagedPropertySuccessPage;
